import React, {useEffect, useState} from 'react';
import Layout from '../components/Layout';
import {api} from '../api';

export default function PayHistory() {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api('/hcm/my-pay-history').then(r => r.ok ? r.json() : []).then(setHistory).finally(() => setLoading(false));
  }, []);

  if (loading) return <Layout><div className="flex justify-center items-center h-64"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600"></div></div></Layout>;

  return (
    <Layout>
      <h2 className="text-2xl font-bold text-gray-900 mb-6">Pay History</h2>
      {history.length === 0 ? (
        <div className="text-center py-12 bg-white rounded-lg shadow"><p className="text-gray-500">No pay history available.</p></div>
      ) : (
        <div className="bg-white rounded-lg shadow overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Effective Date</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Pay Rate</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Type</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Frequency</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Notes</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {history.map(h => (
                <tr key={h.id} className="hover:bg-gray-50">
                  <td className="px-6 py-4 text-gray-900 font-medium">{h.effectiveDate || '—'}</td>
                  <td className="px-6 py-4 text-gray-900">{h.payRate != null ? `$${Number(h.payRate).toLocaleString()}` : '—'}</td>
                  <td className="px-6 py-4 text-gray-600">{h.payType || '—'}</td>
                  <td className="px-6 py-4 text-gray-600">{h.payFrequency || '—'}</td>
                  <td className="px-6 py-4 text-gray-500 text-sm">{h.notes || '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Layout>
  );
}
